<template>
  <div>
    <!-- 筛选项 -->
    <FilterLayout v-model="searchForm" @onSubmit="onSubmit" width="100px" :mdSpan="6" :flexFlag="true">
      <!-- <div class="component_title2">筛选项</div> -->
      <el-col :md="6" :lg="6" :sm="12">
        <!-- prop="refuseTime" -->
        <el-form-item label="被拒时间">
          <dataPicker :datevalue.sync="searchForm.refuseTime" :clearFlag="true"></dataPicker>
        </el-form-item>
      </el-col>
      <el-col :md="6" :sm="12">
        <!-- prop="restoreTime" -->
        <el-form-item label="恢复时间">
          <dataPicker :datevalue.sync="searchForm.restoreTime" :clearFlag="true"></dataPicker>
        </el-form-item>
      </el-col>
      <el-col :md="6" :sm="12">
        <!-- prop="subject" -->
        <el-form-item label="主体">
          <el-select v-model="searchForm.subject" clearable multiple collapse-tags filterable>
            <el-option v-for="(item, ind) in subjectList" :key="ind" :label="item.label" :value="item.val"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :md="6" :sm="12">
        <!-- prop="system" -->
        <el-form-item label="系统">
          <SelectCustomizeNew :value="systemInfo" @changeScope="changeSystem" :data="systemIds" />
        </el-form-item>
      </el-col>
      <el-col :md="6" :sm="12">
        <!-- prop="system" -->
        <el-form-item label="增长部协作者">
          <SelectCustomizeNew :value="increase_admin_id" :data="authorList" :prop="{ label: 'realname' }" />
        </el-form-item>
      </el-col>
      <el-col :md="6" :sm="12">
        <!-- prop="project" -->
        <el-form-item label="项目">
          <SelectCustomizeNew :value="projectInfo" @changeScope="changeArticle" :data="article_id" />
        </el-form-item>
      </el-col>

      <el-col :md="6" :sm="12">
        <!-- prop="appid" -->
        <el-form-item label="应用">
          <SelectCustomizeNew :value.sync="appidInfo" @changeScope="changeAppid" :data="apps" />
        </el-form-item>
      </el-col>
      <el-col :md="6" :sm="12">
        <el-popover trigger="hover" placement="top-end" content="仅在选择一个应用时可用" :disabled="versionPopover">
          <!-- prop="releaseVersion" -->
          <el-form-item label="发布版本" slot="reference">
            <el-select v-model="searchForm.releaseVersion" placeholder="请选择" :disabled="versionDisabled" clearable
              filterable>
              <el-option v-for="(item, ind) in versionV2" :key="ind" :value="item" :label="item"></el-option>
            </el-select>
          </el-form-item>
        </el-popover>
      </el-col>
      <el-col :md="6" :sm="12">
        <!--  prop="auditPlatform" -->
        <el-form-item label="审核平台">
          <el-cascader v-model="searchForm.auditPlatform" :options="second_channels" :props="cascaderProps" clearable
            @change="cascderChange" placeholder="请选择" style="width: 263px" filterable></el-cascader>
          <!-- </el-select> -->
        </el-form-item>
      </el-col>
      <el-col :md="6" :sm="12">
        <!-- prop="coreProblem" -->
        <el-form-item label="核心问题">
          <el-select v-model="searchForm.coreProblem" placeholder="请选择" clearable filterable>
            <el-option v-for="(item, ind) in coreProblemList" :key="ind" :label="item.label"
              :value="item.val"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :md="6" :sm="12">
        <!-- prop="riskLevel" -->
        <el-form-item label="风险等级">
          <el-select v-model="searchForm.riskLevel" placeholder="请选择" multiple collapse-tags clearable filterable>
            <el-option v-for="(item, ind) in riskLevelList" :key="ind" :value="item.val" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :md="6" :sm="12">
        <!-- prop="violation" -->
        <el-form-item label="是否违规">
          <el-select v-model="searchForm.violation" placeholder="请选择" multiple collapse-tags clearable filterable>
            <el-option v-for="(item, ind) in violationList" :key="ind" :label="item.label" :value="item.val"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :md="6" :sm="12">
        <!-- prop="riskConfirm" -->
        <el-form-item label="风险确认">
          <el-select v-model="searchForm.riskConfirm" placeholder="请选择" multiple collapse-tags filterable>
            <el-option v-for="(item, ind) in riskConfirmList" :key="ind" :label="item.label"
              :value="item.val"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-button @click="initFrom" type="primary" slot="btn-option">清除筛选</el-button>
    </FilterLayout>
    <!-- 数据报表 -->
    <TableLayout :column="column" :data="tableData.data" :total="tableData.total" :loading="tableData.loading"
      :currentPage="tableData.currentPage" :params="outPamrms" :leadOut="true" :author="'new'" alignStyle="center"
      @pageChange="onPageChange" @sizeChange="onSizeChange" @sortChange="onSortChange" @leadOutClick="leadOutClick"
      @handleChange="handleSelectionChange($event)" :selection_field="slectNable" :defaultSort="sort"
      selection="selection" :tableType="'default'" :rowKey="tableIds">
      <!-- <div class="component_title" slot="title">数据报表</div> -->
      <el-button @click="recordNew" slot="table-option" type="primary">新增记录</el-button>
      <!-- 按钮权限控制,无权限不展示 -->
      <el-button type="primary" slot="confirm" @click="riskConfirm" :disabled="riskDisabled"
        v-show="btnFlag !== -1">风险确认</el-button>
      <!-- 表单操作 -->
      <template #operation="scope">
        <el-link :underline="false" style="margin-right: 40px; color: #1890ff"
          @click="showDeleteBox(scope.row)">删除</el-link>
        <el-link :underline="false" style="color: #1890ff" @click="compile(scope.row)">编辑</el-link>
      </template>
      <!-- 处理策略 -->
      <template #handle_tactics="scope">
        <el-popover placement="top" trigger="hover" width="400" :content="scope.row.handle_tactics">
          <span slot="reference" class="overFlow">{{
            scope.row.handle_tactics
          }}</span>
        </el-popover>
      </template>
      <!-- 风险确认 -->
      <template #is_ack_text="scope">
        <!-- | ricksConfirm(that) -->
        <span :class="{ confirmColor: scope.row.is_ack == 1 ? 1 : 0 }">{{
          scope.row.is_ack_text
        }}</span>
      </template>
      <!-- 被拒原因 -->
      <template #rejected_content_case_text="scope">
        <el-popover placement="top" trigger="hover" width="400" :content="scope.row.rejected_content_case_text">
          <span slot="reference" class="overFlow">{{
            scope.row.rejected_content_case_text
          }}</span>
        </el-popover>
      </template>

      <!-- 核心问题 -->
      <template #core_issues_text="scope">
        <el-popover placement="top" trigger="hover" width="200" :content="scope.row.core_issues_text">
          <span slot="reference" class="overFlow">{{
            scope.row.core_issues_text
          }}</span>
        </el-popover>
      </template>
      <!-- 原因截图 -->
      <!-- v-for="(item, ind) in scope.row.rejected_content.image"
          :key="ind" -->
      <template #reasonPhoto="scope">
        <!-- <span>{{ scope.row }}</span> -->
        <div v-if="scope.row.rejected_content.image && scope.row.rejected_content.image.length > 0" style="
            width: 120px;
            height: 100px;
            margin: 0 auto 5px;
            border-radius: 6px;
          " @click="visDialog(scope.row.rejected_content.image)">
          <el-image style="
              width: 100%;
              height: 100%;
              object-fit: contain;
              cursor: pointer;
            " :src="scope.row.rejected_content.image[0]"></el-image>
        </div>
        <span v-if="scope.row.rejected_content.image && scope.row.rejected_content.image.length > 0"
          style="font-size: 12px; text-align: center">点击图片进行预览</span>
      </template>
    </TableLayout>
    <imagePreview :dialogImage="dialogImage" v-model="dialogVis" title="原件截图" top="9vh" />
  </div>
</template>

<script>
import moment from "moment";
import store from "store2";
import { Mydata } from "./mixins/index";
import FilterLayout from "@/layout/form";
import TableLayout from "@/layout/table";
import SelectCustomize from "@/component/select-customize";
import SelectCustomizeNew from "@/component/select-customize-new";
import { mapState } from "vuex";

export default {
  mixins: [Mydata],
  components: {
    FilterLayout,
    SelectCustomize,
    SelectCustomizeNew,
    TableLayout,
    imagePreview: () => import("../component/image-preview.vue"),
  },
  computed: {
    ...mapState({
      riskConfirmList: (state) => state.dict_main.review_is_ack,
      coreProblemList: (state) => state.dict_main.review_core_issues,
      riskLevelList: (state) => state.dict_main.review_risk_level,
      violationList: (state) => state.dict_main.review_is_violation,
      subjectList: (state) => state.dict_main.review_subject,
    }),
    outPamrms() {
      // tableOpt
      const { searchForm } = this;
      return {
        ...searchForm,
        // ...tableOpt,
        isDownload: 1,
        leadeOutType: 5,
      };
    },
  },
  data() {
    return {
      that: this,
      // 表格的筛选项
      searchForm: {
        refuseTime: [
          moment().subtract(30, "d").format("YYYY-MM-DD"),
          moment().subtract(0, "d").format("YYYY-MM-DD"),
        ], //被拒时间
        restoreTime: [], //恢复时间
        subject: [], //主体
        project: [], //项目
        system: [], //系统
        appid: [], //应用
        releaseVersion: [], //发布版本
        auditPlatform: [], //审核平台
        coreProblem: "", //核心问题
        riskLevel: [], //风险等级
        violation: [], //是否违规
        riskConfirm: [], //风险确认
        channe: [], //渠道
        timeType: "1", //时间周期
      },
      projectInfo: {
        appInfo: [], //部门-组件件初始数据
      },
      increase_admin_id: {
        appInfo: [], //部门-组件件初始数据
      },
      appidInfo: {
        appInfo: [], //应用-组件列表数据
      },
      systemInfo: {
        appInfo: [], //系统-组件列表数据
      },
      apps: [], //应用-组件回调所选值
      article_id: [], //项目-组件回调所选值
      department_id: [], //事业群数据
      group_id: [], //部门数据
      // 表格数据
      tableData: {
        data: [], //数据
        total: 0, //总页数
        currentPage: 1, //当前页
        pageSize: 10, //每页条数
        loading: false, //加载标杆
        lead_out_total_page: 0, // 导出的总页数
      },
      // 排序
      sort: {
        prop: "",
        order: "",
      },
      riskDisabled: true, //风险确认的禁用
      tabVal: [], //通过多选操作框取到的值
      versionDisabled: true, //版本号的禁用
      versionPopover: false, //版本号(一个应用选择时启用标识)
      channels: [], //审核平台
      versionV2: [], //版本号列表
      second_channels: [], //分类
      selection: "selection",
      editorList: [], //存放编辑的数据
      cascaderProps: {
        value: "id",
        label: "title",
        children: "children",
        multiple: false,
        expandTrigger: "hover",
      },
      channelsSecond: "",
      dialogVis: false, //图片预览层
      dialogImage: [], //预览层图片列表
      firstImage: "", //当前显示的图片
      tableIds: [],
      diaTitle: "",
      btnFlag: -1,
      query: {},
      authorList: []
    };
  },
  created() {
    this.logDeveloper({
      web: '高浩宇',
      back: "刘强"
    })
  },
  async mounted() {
    this.getAuthor()
    // 从APP发版记录跳转过来携带参数进行查询
    this.query = this.$route.query
    this.btnFlag = store.get("menu").indexOf("160");
    //获取审核平台
    await this.getClassify();
    // 初始化调用事业群分组
    await this.getRoleBtree();
    //获取列表数据
    await this.getReviewList();
 
  },
  filters: {},
  methods: {
    //获取协作者列表
    async getAuthor() {
      let res = await this.$http.post("Operate_Invest/getAuthor");
      this.authorList = res[1].admin;
    },
    // 点击导出
    leadOutClick(callBack) {
      this.getReviewList(callBack)
    },
    //回传函数
    slectNable(row) {
      if (row.is_ack_text == "已确认") {
        return false;
      } else {
        return true;
      }
    },
    //获取列表数据
    async getReviewList(callBack) {
      let leadOutData = [];
      this.tableData.loading = true;
      let {
        refuseTime,
        restoreTime,
        subject,
        project,
        system,
        appid,
        releaseVersion,
        coreProblem,
        riskLevel,
        violation,
        riskConfirm,
      } = this.searchForm;
      let { currentPage, pageSize } = this.tableData;
      // let { prop, order } = this.sort;
      let api = "/review/list";
      let params = {
        currentPage: currentPage,
        pageSize: pageSize,
        rejected_date: {
          start_date: refuseTime[0] || "",
          end_date: refuseTime[1] || "",
        },
        resume_date: {
          start_date: restoreTime[0] || "",
          end_date: restoreTime[1] || "",
        },
        subject: subject || [],
        project_id: project || [],
        system: system || [],
        appid: appid || [],
        version: releaseVersion || [],
        platform: this.channelsSecond || [],
        core_issues: coreProblem || "",
        risk_level: riskLevel || [],
        is_violation: violation || [],
        is_ack: riskConfirm || [],
        is_download: callBack ? 1 : undefined,
        increase_admin_id: this.increase_admin_id.appInfo.map(el=>{
          return Number(el)
        })
      };
      if (!callBack) {
        let [err, res] = await this.$http.post(api, {
          ...params,
          field: this.sort.prop,
          order: this.sort.order,
        });

        if (err) return;
        // this.tableData.data = res[1].list;
        if (res.list) {
          this.tableData.data = await this.delData(res.list);
        } else {
          this.tableData.data = [];
        }

        this.tableData.total = res.total;
        this.tableData.lead_out_total_page = Math.ceil(res.total / 1000);
        this.tableData.loading = false;
      }

      if (callBack) {
        for (let i = 0; i < this.tableData.lead_out_total_page; i++) {
          let [err, res] = await this.$http.post(api, {
            ...params,
            currentPage: i + 1,
            sort: "",
            field: "",
          });
          if (err) return;
          if (res.list) {
            leadOutData.push(...res.list);
          }
        }
        if (leadOutData.length > 0) {
          let disposeData = await this.delData(leadOutData);
          callBack.success(disposeData);
        } else {
          callBack.fail();
        }
        this.tableData.loading = false;
      }
    },
    //处理数据
    delData(data) {
      return new Promise((resolve, reject) => {
        for (let i of data) {
          i.subject_text = this.bodyFilt(i.subject);
          i.is_ack_text = this.risk(i.is_ack);
          i.project_id_text = this.project(i.project_id);
          i.appid_text = this.appidFilt(i.appid);
          i.rejected_date = this.timeFilt(i.rejected_date);
          i.resume_date = this.timeFilt(i.resume_date);
          i.rejected_content_case_text = i.rejected_content.cause;
          i.platform_text = this.errPlatform(i.platform);
          i.risk_level_text = this.levelFilt(i.risk_level);
          i.is_violation_text = this.isViolation(i.is_violation);
          i.core_issues_text = this.issuesFiliter(i.core_issues);
          i.increase_admin_id_text = this.getauthor_text(i.increase_admin_id);

          if (i.rejected_content.image && i.rejected_content.image.length > 1) {
            //获取逗号的索引
            i.reasonPhoto = `${i.rejected_content.image
              .join(",")
              .replaceAll(",", "\n")}`;
          } else {
            i.reasonPhoto = i.rejected_content.image;
          }
        }
        resolve(data);
      });
    },
    //负责人过滤
    getauthor_text(val) {
      let auth = "";
      this.authorList.forEach(({ id, realname }) => {
        if (val == id) {
          auth = realname;
        }
      });
      return auth;
    },
    //风险确认过滤
    risk(item) {
      let risk = "";
      this.riskConfirmList.forEach((value) => {
        if (value.val == item) {
          risk = value.label;
        }
      });
      return risk;
    },
    //时间过滤
    timeFilt(val) {
      if (val == null) {
        return "";
      } else {
        return val.split(" ")[0];
      }
    },
    //核心问题过滤
    issuesFiliter(vals) {
      let issues = [];
      vals.split(",").forEach((val) => {
        this.coreProblemList.forEach((value) => {
          if (val == value.val) {
            issues.push(value.label);
          }
        });
      });
      return issues.join(",");
    },
    //主体过滤
    bodyFilt(val) {
      let body = "";
      this.subjectList.forEach((values) => {
        if (values.val == val) {
          body = values.label;
        }
      });
      return body;
    },

    //项目过滤
    project(val) {
      let proj = "";
      this.department_id.forEach(({ node }) => {
        node.forEach(({ node }) => {
          node.forEach((vals) => {
            if (val == vals.id) {
              proj = vals.title;
            }
          });
        });
      });
      return proj;
    },
    //应用过滤
    appidFilt(val) {
      let app = "";
      this.department_id.forEach(({ node }) => {
        node.forEach(({ node }) => {
          node.forEach(({ node }) => {
            node.forEach((vals) => {
              if (val == vals.id) {
                app = vals.title;
              }
            });
          });
        });
      });
      return app;
    },
    //审核平台过滤
    errPlatform(val) {
      let plat = "";
      this.second_channels.forEach(({ children }) => {
        if (children) {
          children.forEach((vals) => {
            if (val == vals.id) {
              plat = vals.title;
            }
          });
        }
      });
      return plat;
    },
    //风险等级过滤
    levelFilt(value) {
      let level = "";
      this.riskLevelList.forEach((vals) => {
        if (vals.val == value) {
          level = vals.label;
        }
      });
      return level;
    },
    //是否违规过滤
    isViolation(value) {
      let violation = "";
      this.violationList.forEach((vals) => {
        if (value == vals.val) {
          violation = vals.label;
        }
      });
      return violation;
    },
    //获取渠道分类
    async getClassify() {
      this.tableData.loading = true;
      let res = await this.$http.post("Invest_Statistics/classify");
      this.second_channels = res[1];
      this.second_channels.forEach(({ id }) => {
        this.getChannels(id);
      });
    },
    //获取审核平台
    async getChannels(id) {
      let res = await this.$http.post("Invest_Statistics/invest_channels", {
        classify_id: id,
      });
      if (id == 1) {
        // this.second_channels[0].children = res[1]
        this.$set(this.second_channels[0], "children", res[1]);
      } else if (id == 2) {
        this.$set(this.second_channels[1], "children", res[1]);
      } else if (id == 4) {
        this.$set(this.second_channels[2], "children", res[1]);
      }
    },
    //获取项目分类数据
    async getRoleBtree() {
      const [err, res] = await this.$http.post("System/roleBtree", {
        loginId: store.get("user")["id"],
        loginToken: store.get("loginToken"),
      });
      if (err) return;
      this.department_id = res.tree;
      res.list.forEach((item) => {
        if (item.title == "应用") {
          item.node.forEach((_item) => {
            if (_item.system == "1") {
              _item.title = _item.title + "_Android";
            } else if (_item.system == "2") {
              _item.title = _item.title + "_IOS";
            } else if (_item.system == "3") {
              _item.title = _item.title + "_微信小程序";
            }
          });
        }
      });
      this.departDatas = [
        ...res.list,
        { id: 1005, title: "系统", node: [...this.systemIds] },
      ];
      let group_id = [];
      res.tree.forEach((item) => {
        item.node.forEach((_item) => {
          group_id.push(_item);
        });
      });
      this.group_id = group_id;
      let apps = [];
      let article_id_arr = [];
      res.tree.forEach((item) => {
        item.node.forEach((_item) => {
          article_id_arr.push(..._item.node);
          _item.node.forEach((__item) => {
            apps.push(...__item.node);
          });
        });
      });
      this.apps = apps;
      // 从APP发版记录跳转过来携带参数进行查询
      if (this.query.appid) {
        // 回显应用
        const arr = [this.query.appid]
        this.appidInfo.appInfo = arr
        // 回显版本号
        this.changeAppid({
          appInfo: arr,
          optionList: [{ id: this.query.appid }]
        })
        this.searchForm.releaseVersion = this.query.version
        this.searchForm.refuseTime = []
      }

      this.article_id = article_id_arr;
    },
    // 改变项目
    changeArticle(val) {
      this.searchForm.project = val.appInfo;
      this.searchForm.appid = [];
      this.appidInfo.appInfo = [];
      let apps_arr = [];
      if (this.searchForm.project.length) {
        this.searchForm.project.forEach((item) => {
          this.department_id.forEach((_item) => {
            _item.node.forEach((__item) => {
              __item.node.forEach((item_) => {
                if (item == item_.id) {
                  apps_arr.push(...item_.node);
                }
              });
            });
          });
        });
      } else {
        this.article_id.forEach((item) => {
          apps_arr.push(...item.node);
        });
      }
      this.apps = apps_arr;
    },
    // 筛选应用的回调函数
    changeAppid(val) {
      this.searchForm.appid = val.appInfo;
      if (val.appInfo.length == 1) {
        this.getVersionV2(val.optionList[0].id);
        this.versionDisabled = false;
        this.versionPopover = true;
      } else {
        this.searchForm.releaseVersion = [];
        this.versionDisabled = true;
        this.versionPopover = false;
      }
    },
    //获取版本号
    async getVersionV2(id) {
      let res = await this.$http.post("App/getVersionV2", { appId: id });
      this.versionV2 = Array.from(new Set(res[1]));
    },
    // 筛选系统的回调函数
    changeSystem(val) {
      this.searchForm.system = val.appInfo;
    },
    // 表单查询
    onSubmit() {
      this.tableData.currentPage = 1
      this.sort.order = "";
      this.sort.prop = "";
      this.getReviewList();
    },
    // 重置表单
    initFrom() {
      this.projectInfo.appInfo = [];
      this.appidInfo.appInfo = [];
      this.systemInfo.appInfo = [];
      this.increase_admin_id.appInfo = []
      this.channelsSecond = "";
      this.searchForm = {
        //筛选项
        appid: [],
        system: [],
        timeType: "1",
        refuseTime: [
          moment().subtract(30, "d").format("YYYY-MM-DD"),
          moment().subtract(0, "d").format("YYYY-MM-DD"),
        ],
        restoreTime: [
          // moment().subtract(7, "d").format("YYYY-MM-DD"),
          // moment().subtract(1, "d").format("YYYY-MM-DD"),
        ],
        riskConfirm: [],
        violation: [],
        riskLevel: [],
        coreProblem: "",
        auditPlatform: [],
        releaseVersion: [],
        subject: [],
      };
    },
    // 每页改变回调
    onPageChange(current) {
      this.tableData.currentPage = current;
      this.sort.order = "";
      this.sort.prop = "";
      this.getReviewList();
    },
    // 每页条数改变回调
    onSizeChange(current) {
      this.tableData.pageSize = current;
      this.sort.order = "";
      this.sort.prop = "";
      this.getReviewList();
    },
    // 表格排序的回调
    onSortChange(data) {
      if (data.order == "descending") {
        this.sort.order = data.order.substring(0, 4);
        this.sort.prop = data.prop;
        this.getReviewList();
      } else if (data.order == "ascending") {
        this.sort.order = data.order.substring(0, 3);
        this.sort.prop = data.prop;
        this.getReviewList();
      } else {
        this.sort.roder = "";
        this.sort.prop = data.prop;
      }
    },
    // 跳转新增记录
    recordNew() {
      this.$router.push({
        path: "/business_center/subsidiary_management/auditing_unusual_add",
      });
    },
    //风险确认
    riskConfirm() {
      this.$confirm("是否确认该风险?", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          let arr = []
          this.tabVal.forEach(val => {
            arr.push(val.id)
          })
          this.$http
            .post("/review/ack", {
              id: arr,
            })
            .then((res, err) => {
              if (err) return;
              if (res[3] == "success") {
                this.$message.success("风险确认成功");
                this.sort.order = "";
                this.sort.prop = "";
                this.getReviewList();
                this.riskDisabled = true;
                this.tabVal = [];
              }
            });
        })
        .catch(() => {
          this.$message.warning("已取消");
        });
    },
    //select选项框和风险确认进行联动处理
    handleSelectionChange(val) {
      this.tabVal = val
      if (this.tabVal.length == 0) {
        this.riskDisabled = true;
      } else {
        this.riskDisabled = false;
      }
    },
    //打开表单中的删除确认框
    showDeleteBox(row) {
      this.$confirm("此操作不可逆转,是否删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$http.post("/review/del", { id: row.id }).then((res) => {
            if (res[3] == "success") {
              this.getReviewList();
              this.$message.success("删除成功");
            } else {
              this.$message.warning("删除失败,请稍后再试");
            }
          });
        })
        .catch(() => {
          this.$message.warning("已取消删除");
        });
    },
    //表单的编辑
    compile(row) {
      localStorage.setItem("rows", JSON.stringify(row));
      this.$router.push({
        path: "/business_center/subsidiary_management/auditing_unusual_add",
      });
    },
    cascderChange(val) {
      this.channelsSecond = val[1];
    },
    visDialog(val) {
      this.dialogImage = val;
      this.firstImage = val[0];
      this.dialogVis = true;
    },
  },
};
</script>

<style lang="less" scoped>
.top-box {
  margin-bottom: 20px;

  .btn {
    margin-top: 20px;
  }
}

.component_title2 {
  background: #fff;
  padding: 1px 0 10px 15px;
  font-weight: bold;
}

.component_title {
  background: #fff;
  padding: 20px 0 10px 15px;
  font-weight: bold;
}

.font14 {
  font-size: 14px;
}

.Tab_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;

  button {
    margin-right: 20px;
  }

  .left_box {
    line-height: 40px;
    // width: 1000px;
    display: flex;

    .btns {
      margin-left: 20px;
    }
  }
}

.my-select {
  height: 40px;
}

.check-all {
  padding: 0 20px;
  text-align: right;
}

.confirmColor {
  color: #1890ff;
}

.overFlow {
  display: -webkit-box;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
</style>
<style>
.el-table--border .el-table__cell:first-child .cell {
  text-align: center;
}
</style>
